(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    const otStickyCartSelector = '.sticky-add-to-cart__bar';
  const otStickyCartRoot = document.documentElement;

  if (!otStickyCartRoot.hasAttribute('data-ot-sticky-cart-viewport')) {
    otStickyCartRoot.setAttribute('data-ot-sticky-cart-viewport', '');

    let otStickyCartFrame;
    let otStickyCartResizeObserver;

    const syncOtStickyCart = () => {
      otStickyCartFrame = undefined;
      const viewport = window.visualViewport;
      const bars = document.querySelectorAll(otStickyCartSelector);

      if (!viewport || !window.matchMedia('(max-width: 749px)').matches) {
        bars.forEach((bar) => {
          bar.style.removeProperty('top');
          bar.style.removeProperty('bottom');
        });
        return;
      }

      bars.forEach((bar) => {
        const barHeight = bar.getBoundingClientRect().height;
        if (barHeight === 0) return;

        const visibleBottom = viewport.offsetTop + viewport.height;
        const barTop = Math.round(visibleBottom - barHeight);
        bar.style.setProperty('top', `${barTop}px`, 'important');
        bar.style.setProperty('bottom', 'auto', 'important');
      });
    };

    const requestOtStickyCartSync = () => {
      if (otStickyCartFrame) cancelAnimationFrame(otStickyCartFrame);
      otStickyCartFrame = requestAnimationFrame(syncOtStickyCart);
    };

    const observeOtStickyCart = () => {
      if ('ResizeObserver' in window) {
        if (!otStickyCartResizeObserver) {
          otStickyCartResizeObserver = new ResizeObserver(requestOtStickyCartSync);
        }
        document.querySelectorAll(otStickyCartSelector).forEach((bar) => otStickyCartResizeObserver.observe(bar));
      }
      requestOtStickyCartSync();
    };

    window.addEventListener('resize', requestOtStickyCartSync, { passive: true });
    window.addEventListener('orientationchange', requestOtStickyCartSync, { passive: true });
    window.addEventListener('pageshow', observeOtStickyCart);
    window.visualViewport?.addEventListener('resize', requestOtStickyCartSync, { passive: true });
    window.visualViewport?.addEventListener('scroll', requestOtStickyCartSync, { passive: true });
    document.addEventListener('shopify:section:load', observeOtStickyCart);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeOtStickyCart, { once: true });
    } else {
      observeOtStickyCart();
    }
  }
  } catch(e) { console.error(e); }
})();

})();
